import { Routes, Route, Navigate } from "react-router-dom";

import Login from "../pages/Login/Login";
import Dashboard from "../pages/Dashboard/Dashboard";
import ProtectedRoute from "../components/ProtectedRoute/ProtectedRoute";
import NewsForm from "../pages/News/NewsForm";
import NewsList from "../pages/News/NewsList";
import TestimonialList from "../pages/Testimonial/TestimonialList";
import TestimonialForm from "../pages/Testimonial/TestimonialForm";
import GalleryList from "../pages/Gallery/GalleryList";
import GalleryForm from "../pages/Gallery/GalleryForm";
import VideoList from "../pages/Video/VideoList";
import VideoForm from "../pages/Video/VideoForm";
import EventList from "../pages/Event/EventList";
import EventForm from "../pages/Event/EventForm";
import EventGallery from "../pages/Event/EventGallery";
import AwardList from "../pages/Award/AwardList";
import AwardForm from "../pages/Award/AwardForm";
import ClientList from "../pages/Client/ClientList";
import ClientForm from "../pages/Client/ClientForm";
import TeamMemberList from "../pages/TeamMember/TeamMemberList";
import TeamMemberForm from "../pages/TeamMember/TeamMemberForm";
import FaqList from "../pages/Faq/FaqList";
import FaqForm from "../pages/Faq/FaqForm";
import ChangePassword from "../pages/ChangePassword/ChangePassword";
import CaseStudyList from "../pages/CaseStudies/CaseStudyList";
import CaseStudyForm from "../pages/CaseStudies/CaseStudyForm";

export default function AppRoutes() {
    return (
        <Routes>
            <Route path="/" element={<Navigate to="/login" replace />} />

            <Route path="/login" element={<Login />} />
            <Route
                path="/dashboard"
                element={
                    <ProtectedRoute>
                        <Dashboard />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/news"
                element={
                    <ProtectedRoute>
                        <NewsList />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/news/add"
                element={
                    <ProtectedRoute>
                        <NewsForm />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/news/edit/:id"
                element={
                    <ProtectedRoute>
                        <NewsForm />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/testimonials"
                element={
                    <ProtectedRoute>
                        <TestimonialList />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/testimonials/add"
                element={
                    <ProtectedRoute>
                        <TestimonialForm />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/testimonials/edit/:id"
                element={
                    <ProtectedRoute>
                        <TestimonialForm />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/gallery"
                element={
                    <ProtectedRoute>
                        <GalleryList />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/gallery/add"
                element={
                    <ProtectedRoute>
                        <GalleryForm />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/gallery/edit/:id"
                element={
                    <ProtectedRoute>
                        <GalleryForm />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/videos"
                element={
                    <ProtectedRoute>
                        <VideoList />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/videos/add"
                element={
                    <ProtectedRoute>
                        <VideoForm />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/videos/edit/:id"
                element={
                    <ProtectedRoute>
                        <VideoForm />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/events"
                element={
                    <ProtectedRoute>
                        <EventList />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/events/add"
                element={
                    <ProtectedRoute>
                        <EventForm />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/events/edit/:id"
                element={
                    <ProtectedRoute>
                        <EventForm />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/events/:id/gallery"
                element={
                    <ProtectedRoute>
                        <EventGallery />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/awards"
                element={
                    <ProtectedRoute>
                        <AwardList />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/awards/add"
                element={
                    <ProtectedRoute>
                        <AwardForm />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/awards/edit/:id"
                element={
                    <ProtectedRoute>
                        <AwardForm />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/clients"
                element={
                    <ProtectedRoute>
                        <ClientList />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/clients/add"
                element={
                    <ProtectedRoute>
                        <ClientForm />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/clients/edit/:id"
                element={
                    <ProtectedRoute>
                        <ClientForm />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/team-members"
                element={
                    <ProtectedRoute>
                        <TeamMemberList />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/team-members/add"
                element={
                    <ProtectedRoute>
                        <TeamMemberForm />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/team-members/edit/:id"
                element={
                    <ProtectedRoute>
                        <TeamMemberForm />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/faqs"
                element={
                    <ProtectedRoute>
                        <FaqList />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/faqs/add"
                element={
                    <ProtectedRoute>
                        <FaqForm />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/faqs/edit/:id"
                element={
                    <ProtectedRoute>
                        <FaqForm />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/change-password"
                element={
                    <ProtectedRoute>
                        <ChangePassword />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/case-studies"
                element={
                    <ProtectedRoute>
                        <CaseStudyList />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/case-studies/add"
                element={
                    <ProtectedRoute>
                        <CaseStudyForm />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/case-studies/edit/:id"
                element={
                    <ProtectedRoute>
                        <CaseStudyForm />
                    </ProtectedRoute>
                }
            />
        </Routes>

    );
}